import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import './index.css'

// Pages
import IndexPage from './routes/index'
import LiffRichmenuPage from './routes/liff/richmenu'
import LiffMirrorPage from './routes/liff/mirror'
import BillingLinkPage from './routes/link/billing'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<IndexPage />} />
        <Route path="/index" element={<IndexPage />} />
        <Route path="/billing" element={<Navigate to="/" replace />} />
        <Route path="/liff/richmenu" element={<LiffRichmenuPage />} />
        <Route path="/liff/mirror" element={<LiffMirrorPage />} />
        <Route path="/link/billing/:token" element={<BillingLinkPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
)
